export default __webpack_public_path__ + "static/media/clashing-edu-logo-vertical-currentColor-orange.6345bf97.svg";